var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import { Student } from '@/models/Student';
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import ErrorHandler from '@/support/ErrorHandler';
import { DateTime } from 'luxon';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { ucstring } from '@/support/String';
import { UserFile } from '@/models/UserFile';
import { RolesEnum } from '@/items/Roles';
const html2pdf = require('html2pdf.js');
let Notes = class Notes extends Vue {
    constructor() {
        super(...arguments);
        this.activeTab = '/notes';
        this.content = '';
        this.noteName = '';
        this.isCreatingPDF = false;
        this.isSavingAndUploading = false;
        this.isUploadingToDrive = false;
        this.editorOptions = {
            modules: {
                magicUrl: true,
            },
        };
    }
    get dialogOptions() {
        return {
            title: this.$t('dialogOptions.confirmation').toString(),
            text: ucstring(this.$t('dialogOptions.save', { item: this.$t('dialogOptions.item.note') }).toString()),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                },
            },
        };
    }
    mounted() {
        this.fetchStudent();
        this.switchQuillLanguage();
        this.$root.$on('locale-changed', this.switchQuillLanguage);
    }
    fetchStudent() {
        if (!this.student) {
            return;
        }
        new Student()
            .include('note')
            .find(this.student.id)
            .then((student) => {
            if (typeof student.note === 'string') {
                this.content = student.note;
                return;
            }
            else {
                this.content = student.note.text || '';
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    onEditorChange(quill, html) {
        this.content = html;
    }
    onEditorReady(quill) {
        //
    }
    onEditorBlur(quill) {
        //
    }
    onEditorFocus(quill) {
        //
    }
    saveAndUpload() {
        this.isSavingAndUploading = true;
        this.save();
        this.exportQuill();
    }
    save() {
        this.student
            .update({ note: this.content })
            .then(() => {
            //
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    exportQuill() {
        this.isUploadingToDrive = false;
        const element = document.getElementsByClassName('ql-editor')[0];
        if (!element) {
            return;
        }
        this.isCreatingPDF = true;
        const header = document.createElement('h1');
        header.innerText = `${this.$t('subject.tab.notes')} - ${this.student.name || ''} - ${DateTime.local().toFormat('yyyy-LL-dd')}`;
        element.prepend(header);
        element.removeAttribute('data-placeholder');
        const filename = this.noteName;
        const html2pdfOptions = {
            margin: 0,
            filename,
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: window.devicePixelRatio, imageTimeout: 0, useCORS: true },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
        };
        // New Promise-based usage:
        if (this.isSavingAndUploading) {
            html2pdf()
                .set(html2pdfOptions)
                .from(element)
                .output('blob')
                .then((val) => {
                this.blobToFile(val, filename);
                header.remove();
                this.isCreatingPDF = false;
                this.$store.dispatch('openDialog', this.dialogOptions);
            });
            return;
        }
        html2pdf()
            .set(html2pdfOptions)
            .from(element)
            .save()
            .then(() => {
            header.remove();
            this.isCreatingPDF = false;
            this.$store.dispatch('openDialog', this.dialogOptions);
        });
    }
    blobToFile(blob, fileName) {
        const tempBlob = blob;
        tempBlob.lastModifiedDate = new Date();
        tempBlob.name = fileName;
        const notesFile = blob;
        this.uploadFileToScoolDrive(notesFile, fileName);
    }
    closeDialog() {
        this.$emit('closed');
    }
    switchQuillLanguage() {
        const editor = this.$refs.studentNotes;
        if (!editor) {
            return;
        }
        const placeholder = this.$t('quillEditor.placeholder').toString();
        editor.quill.root.dataset.placeholder = placeholder;
    }
    uploadFileToScoolDrive(notesFile, fileName) {
        new UserFile()
            .user(this.student)
            .createWithACL(notesFile, fileName, [RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.ROOT])
            .then((response) => {
            if (response) {
                this.isSavingAndUploading = false;
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
};
__decorate([
    Model('student', { default: () => new Student() }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], Notes.prototype, "student", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], Notes.prototype, "dialog", void 0);
Notes = __decorate([
    Component({
        components: {
            'quill-editor': quillEditor,
            'loader-card': LoaderCard,
        },
    })
], Notes);
export default Notes;
